export default function initialsFor(name) {
  return (name || "").split(" ").filter(Boolean).slice(0, 2).map((part) => part[0].toUpperCase()).join("");
}
